module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!this.onboardingModalShowing) ? _c('div', [_c('router-view'), _vm._v(" "), (this.emptyState === 'projects' && this.currentUserIsAdmin) ? _c('empty-state', {
    attrs: {
      "name": "projects",
      "heading": _vm.emptyStateHeading,
      "subtitle": _vm.emptyStateSubtitle,
      "button": true
    }
  }) : (this.emptyState === 'projects' && !this.currentUserIsAdmin) ? _c('div', {
    staticClass: "collaborator-empty-state"
  }, [_c('empty-state', {
    attrs: {
      "name": "projects",
      "heading": _vm.emptyStateHeadingUser,
      "subtitle": _vm.emptyStateSubtitleUser,
      "button": false
    }
  }), _vm._v(" "), (_vm.invitedByUserId && !_vm.isSubmited) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.sendEmail
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.empty_state.projects.btn')))]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "opacity"
    }
  }, [(_vm.isSubmited) ? _c('div', {
    class: {
      'success-msg': _vm.isSubmited
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/success-icon.svg")
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('ui.empty_state.projects.success_message')))])]) : _vm._e()])], 1) : _c('div', {
    staticClass: "project-show project-collection"
  }, [_c('searchbar', {
    attrs: {
      "value": _vm.query.search,
      "model": _vm.model
    },
    on: {
      "search": _vm.search
    }
  }), _vm._v(" "), _c('projects-listing', {
    class: {
      'hideScroll': _vm.wizardModalShowing
    },
    attrs: {
      "loading": _vm.loading,
      "data": _vm.items,
      "structure": _vm.collectionData,
      "params": {
        global_sorting: true,
        sort_by: this.query.sort_by,
        sort_order: this.query.sort_order
      },
      "model": "project_lead",
      "has_searched": _vm.has_searched
    },
    on: {
      "sorting": _vm.sorting,
      "itemDelete": _vm.itemDelete
    }
  }), _vm._v(" "), _c('pagination', {
    attrs: {
      "page": _vm.page,
      "total-pages": _vm.total_pages
    },
    on: {
      "goToPage": _vm.goToPage
    }
  })], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd9e43e0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/projects/Projects.vue
// module id = 1984
// module chunks = 0